export enum InputActivity {
  ADDRESS_ENTER = 'addressEnter',
  ADDRESS_MANUAL = 'addressManual',
  ADDRESS_ENTER_ERROR = 'addressEnterError',
  FIRST_AVAILABLE_DATE = 'firstAvailableDate',
  DATE_SELECTED = 'dateSelected',
  IN_ZONE = 'inZone',
  OUT_OF_ZONE = 'outOfZone',
  OUT_OF_ZONE_VEHICLE = 'outOfZoneVehicle',
  OUT_OF_ZONE_STORE = 'outOfZoneStore',
  SCREENING_ZIP = 'screeningZip',
  SCREENING_FLOOR = 'screeningFloor',
  SCREENING_DISASSEMBLY = 'screeningDisassembly',
  SCREENING_RESTRICTED_ITEMS = 'screeningRestrictedItems',
  SCREENING_DAMAGED = 'screeningDamaged',
}

export enum ButtonActivity {
  ADDRESS_ATTEMPT = 'addressAttempt',
  GOODWILL_SHOP_LANDING_PAGE_SUBMIT = 'goodwillShopLandingPageSubmit',
  PRIORITY_OPTION_CLICKED = 'priorityOption',
  FREE_OPTION_CLICKED = 'freeOption',
  DONATION_SPEC_XL = 'donationSpecXLarge',
  DONATION_SPEC_LG = 'donationSpecLarge',
  DONATION_SPEC_MD = 'donationSpecMedium',
  DONATION_SPEC_SM = 'donationSpecSmall',
  DONATION_SPEC_STAIR_CASES = 'donationSpecStairCases',
  DONATION_SPEC_ELEVATOR = 'donationSpecElevator',
  DONATION_SPEC_DISASSEMBLY = 'donationSpecDisassembly',
  DONATION_SPEC_SUBMIT = 'donationSpecSubmit',
  DONATION_ITEM_SEARCH = 'donationItemSearch',
  DONATION_ITEM_SEARCH_RESULTS = 'donationItemSearchResults',
  CUSTOM_ITEM_CREATE = 'customItemCreate',
  ITEM_REMOVAL_POPUP = 'itemRemovalPopup',
  ITEM_REMOVAL_SUCCESS = 'itemRemovalSuccess',
  ITEM_PREVIEW = 'itemPreview',
  ITEM_ADDED = 'itemAdded',
  DISASSEMBLY_ADDED = 'disassemblyAdded',
  DONATION_FLOOR_SUBMIT = 'donationFloorSubmit',
  DONATION_SPEC_SUBMIT_ERROR = 'donationSpecSubmitError',
  DONATION_FLOOR_SUBMIT_ERROR = 'donationFloorSubmitError',
  AVAILABILITY_SUBMIT = 'availabilitySubmit',
  AVAILABILITY_SUBMIT_ERROR = 'availabilitySubmitError',
  DONOR_INFO_SUBMIT = 'donorInfoSubmit',
  DONOR_INFO_SUBMIT_ERROR = 'donorInfoSubmitError',
  PAYMENT_CHECKBOX = 'paymentCheckbox',
  PAYMENT_SETUP_SUBMIT = 'paymentSetupSubmit',
  PAYMENT_SETUP_SUCCESS_APPLE = 'paymentSetupSuccessApple',
  PAYMENT_SETUP_SUCCESS_GOOGLE = 'paymentSetupSuccessGoogle',
  PAYMENT_SETUP_SUBMIT_ERROR = 'paymentSetupSubmitError',
  SCREENING_SUBMIT = 'screeningSubmit',
  SCREENING_SUBMIT_ERROR = 'screeningSubmitError',
  SCREENING_STANDARD = 'screeningStandard',
  SCREENING_PRIORITY = 'screeningPriority',
  SCREENING_DROP_OFF = 'screeningDropOff',
  SCREENING_YOUTUBE = 'screeningYoutube',
  SMS_CHECKBOX = 'smsCheckbox',
  STAIRCASE_POPUP_SUBMIT = 'staircasePopupSubmit',
  SHOW_ABOUT_RESUPPLY_VIDEO = 'showAboutResupplyVideo',
  EDIT_ITEMS_FROM_PAYMENT = 'editItemsFromPayment',

  // ************************ LEAD CAPTAIN BUTTON ACTIVITIES ***********************

  WIZARD_UI = 'wizardUi',
  LEGACY_UI = 'legacyUi',

  EXPAND_ADDRESS = 'expandAddress',
  EXPAND_ADDRESS_CONFIRM = 'expandAddressConfirm',
  EXPAND_ADDRESS_DISMISS = 'expandAddressDismiss',
  SAVE_ADDRESS = 'saveAddress',
  SAVE_ADDRESS_FAIL = 'saveAddressFail',
  SAVE_ADDRESS_SUCCESS = 'saveAddressSuccess',

  EXPAND_ITEMS = 'expandItems',
  EXPAND_ITEMS_CONFIRM = 'expandItemsConfirm',
  EXPAND_ITEMS_DISMISS = 'expandItemsDismiss',
  SAVE_ITEMS = 'saveItems',
  SAVE_ITEMS_FAIL = 'saveItemsFail',
  SAVE_ITEMS_SUCCESS = 'saveItemsSuccess',

  EXPAND_FLOOR = 'expandFloor',
  EXPAND_FLOOR_CONFIRM = 'expandFloorConfirm',
  EXPAND_FLOOR_DISMISS = 'expandFloorDismiss',
  HAS_ELEVATOR = 'hasElevator',
  SAVE_FLOOR = 'saveFloor',
  SAVE_FLOOR_FAIL = 'saveFloorFail',
  SAVE_FLOOR_SUCCESS = 'saveFloorSuccess',

  EXPAND_AVAILABILITY = 'expandAvailability',
  EXPAND_AVAILABILITY_CONFIRM = 'expandAvailabilityConfirm',
  EXPAND_AVAILABILITY_DISMISS = 'expandAvailabilityDismiss',
  SAVE_AVAILABILITY = 'saveAvailability',
  SAVE_AVAILABILITY_FAIL = 'saveAvailabilityFail',
  SAVE_AVAILABILITY_SUCCESS = 'saveAvailabilitySuccess',

  EXPAND_CHARITY = 'expandCharity',
  EXPAND_CHARITY_CONFIRM = 'expandCharityConfirm',
  EXPAND_CHARITY_DISMISS = 'expandCharityDismiss',
  SAVE_CHARITY = 'saveCharity',
  SAVE_CHARITY_FAIL = 'saveCharityFail',
  SAVE_CHARITY_SUCCESS = 'saveCharitySuccess',
  AUTO_ASSIGN_TOGGLE = 'autoAssignToggle',
  AUTO_ASSIGN_CHARITY = 'autoAssignCharity',
  AUTO_ASSIGN_CHARITY_FAIL = 'autoAssignCharityFail',
  AUTO_ASSIGN_CHARITY_SUCCESS = 'autoAssignCharitySuccess',

  EXPAND_REVIEW = 'expandReview',
  SAVE_REVIEW = 'saveReview',
  SAVE_REVIEW_FAIL = 'saveReviewFail',
  SAVE_REVIEW_SUCCESS = 'saveReviewSuccess',

  EXPAND_INFO = 'expandInfo',
  SAVE_INFO = 'saveInfo',
  SAVE_INFO_FAIL = 'saveInfoFail',
  SAVE_INFO_SUCCESS = 'saveInfoSuccess',

  EXPAND_PAYMENT_OPTIONS = 'expandPaymentOptions',
  SAVE_PAYMENT_OPTIONS = 'savePaymentOptions',
  SAVE_PAYMENT_OPTIONS_FAIL = 'savePaymentOptionsFail',
  SAVE_PAYMENT_OPTIONS_SUCCESS = 'savePaymentOptionsSuccess',

  EXPAND_CONVERT = 'expandConvert',
  SUBMIT_CARD = 'submitCard',
  SUBMIT_CARD_SUCCESS = 'submitCardSuccess',
  SUBMIT_CARD_FAIL = 'submitCardFail',
  CONVERT = 'convert',
  CONVERT_SUCCESS = 'convertSuccess',
  CONVERT_FAIL = 'convertFail',

  // ************************ DONATION BUTTON ACTIVITIES ***********************
  ADD_TO_CALENDAR = 'addToCalendar',
  RESCHEDULE_DONATION = 'rescheduleDonation',
  RESCHEDULE_DONATION_SUBMIT = 'rescheduleDonationSubmit',
  RESCHEDULE_DONATION_SUBMIT_ERROR = 'rescheduleDonationSubmitError',
  CANCEL_DONATION = 'cancelDonation',
  CANCEL_DONATION_POPUP = 'cancelDonationPopup',
  CANCEL_DONATION_SUBMIT = 'cancelDonationSubmit',
  CANCEL_DONATION_SUBMIT_ERROR = 'cancelDonationSubmitError',
  EDIT_DONOR_INFO = 'editDonorInfo',
  EDIT_DONOR_INFO_SUBMIT = 'editDonorInfoSubmit',
  EDIT_DONOR_INFO_SUBMIT_ERROR = 'editDonorInfoSubmitError',
  EDIT_DONATION_SPEC = 'editDonationSpec',
  EDIT_DONATION_SPEC_SUBMIT = 'editDonationSpecSubmit',
  EDIT_DONATION_SPEC_SUBMIT_ERROR = 'editDonationSpecSubmitError',
  ADD_DONATION_PHOTOS = 'addDonationPhotos',
  ADD_DONATION_PHOTOS_SUBMIT = 'addDonationPhotosSubmit',
  ADD_DONATION_PHOTOS_SUBMIT_ERROR = 'addDonationPhotosSubmitError',
  TAX_RECEIPT = 'taxReceipt',
  RECEIPT = 'receipt',
  CONTINUE_TO_PAYMENT = 'continueToPayment',
  CONFIRM_PAYMENT = 'confirmPayment',
  CONFIRM_PAYMENT_ERROR = 'confirmPaymentError',
  SUBMIT_REVIEW = 'submitReview',
  SUBMIT_REVIEW_ERROR = 'submitReviewError',
  YELP = 'yelp',
  GOOGLE_MY_BUSINESS = 'googleMyBusiness',
  BETTER_BUSINESS_BUREAU = 'betterBusinessBureau',
  REQUEST_ETA = 'requestETA',
  UNKNOWN = 'unknown',
  GRATUITY_WARNING_SHOWN = 'gratuityWarningShown',
}

export enum PageActivity {
  // ************************ LEAD PAGE ACTIVITIES ***************************
  GOODWILL_SHOP_LANDING_PAGE = 'goodwillShopLanding',
  SPLIT_LANDING_PAGE = 'splitLanding',
  SCREENING_PAGE = 'screening',
  DONATION_SPEC_PAGE = 'donationSpec',
  DONATION_FLOOR_PAGE = 'donationFloor',
  AVAILABILITY_PAGE = 'availability',
  DONOR_INFO_PAGE = 'donorInfo',
  PAYMENT_SETUP_PAGE = 'paymentSetup',
  SPLASH_SCREEN_PAGE = 'splashScreen',

  // ************************ DONATION PAGE ACTIVITIES ***********************
  DONATION_MANAGEMENT_PAGE = 'donationManagement',
  EDIT_DONATION_PAGE = 'editDonation',
  RESCHEDULE_DONATION_PAGE = 'donationReschedule',
  CANCEL_DONATION_PAGE = 'donationCancellation',
  EDIT_DONOR_INFO_PAGE = 'donorInfoEdit',
  EDIT_DONATION_SPEC_PAGE = 'donationSpecEdit',
  DONATION_PHOTOS_PAGE = 'donationPhotos',
  PAYMENT_AUTHORIZATION_PAGE = 'paymentAuthorization',
  PAYMENT_SUCCESS_PAGE = 'paymentSuccess',
}

export enum CustomActivity {
  LEAD_DROPPED = 'leadDropped',
  EXPAND_ADDRESS_WARNING_POPUP = 'expandAddressWarningPopUp',
  EXPAND_ITEMS_WARNING_POPUP = 'expandItemsWarningPopUp',
  EXPAND_FLOOR_WARNING_POPUP = 'expandFloorWarningPopUp',
  EXPAND_AVAILABILITY_WARNING_POPUP = 'expandAvailabilityWarningPopUp',
  AUTO_ASSIGN_NOT_AVAILABLE = 'autoAssignNotAvailable',
  EXPAND_CHARITY_WARNING_POPUP = 'expandCharityWarningPopUp',
}

export const googleTagManagerPageActivities = [
  PageActivity.SPLIT_LANDING_PAGE,
  PageActivity.DONATION_SPEC_PAGE,
  PageActivity.DONATION_FLOOR_PAGE,
  PageActivity.AVAILABILITY_PAGE,
  PageActivity.DONOR_INFO_PAGE,
  PageActivity.PAYMENT_SETUP_PAGE,
  PageActivity.SPLASH_SCREEN_PAGE,
];
